var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11868_63308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0204 9.65845L15.5212 16.0961H13.6741L10.0014 10.843V10.8426L9.46218 10.0715L5.17188 3.93457H7.01898L10.4812 8.8873L11.0204 9.65845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1905 0H2.51261C1.31913 0 0.351562 0.967563 0.351562 2.16104V17.839C0.351562 19.0324 1.31913 20 2.51261 20H18.1905C19.384 20 20.3516 19.0324 20.3516 17.839V2.16104C20.3516 0.967563 19.384 0 18.1905 0ZM13.1082 16.9604L9.39166 11.5514L4.73852 16.9604H3.53591L8.85767 10.7746L3.53591 3.02934H7.59492L11.1142 8.15126L15.5204 3.02934H16.723L11.6484 8.92828H11.6481L17.1672 16.9604H13.1082Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11868_63308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.351562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialX);
export default __webpack_public_path__ + "static/media/Social-X.286b20e5da2b14078cf4d3fac023850c.svg";
export { ForwardRef as ReactComponent };